import { fo_monan_chitiet } from '../../../models/response/dich-vu/food/fo_monan_chitiet';

export enum eFoMonAnChiTietActionTypeIds {
	LOAD_START = "FO_MONANCHITIET_LOAD_START",
	LOAD_SUCCESS = "FO_MONANCHITIET_LOAD_SUCCESS",
	LOAD_ERROR = "FO_MONANCHITIET_LOAD_ERROR",

	LOAD_DETAIL_START = "FO_MONANCHITIET_LOAD_DETAIL_START",
	LOAD_DETAIL_SUCCESS = "FO_MONANCHITIET_LOAD_DETAIL_SUCCESS",
	LOAD_DETAIL_ERROR = "FO_MONANCHITIET_LOAD_DETAIL_ERROR",

	SHOW_DETAIL = "FO_MONANCHITIET_SHOW_DETAIL",
	CLOSE_DETAIL = "FO_MONANCHITIET_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "FO_MONANCHITIET_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "FO_MONANCHITIET_SHOW_CONFIRM",
	CLOSE_CONFIRM = "FO_MONANCHITIET_CLOSE_CONFIRM",

	SAVE_START = "FO_MONANCHITIET_SAVE_START",
	SAVE_SUCCESS = "FO_MONANCHITIET_SAVE_SUCCESS",
	SAVE_ERROR = "FO_MONANCHITIET_SAVE_ERROR",

	DELETE_START = "FO_MONANCHITIET_DELETE_START",
	DELETE_SUCCESS = "FO_MONANCHITIET_DELETE_SUCCESS",
	DELETE_ERROR = "FO_MONANCHITIET_DELETE_ERROR"
}

export interface IFoMonAnChiTietLoadStart {
	type: eFoMonAnChiTietActionTypeIds.LOAD_START,
	payload: number
}
export interface IFoMonAnChiTietLoadSuccess {
	type: eFoMonAnChiTietActionTypeIds.LOAD_SUCCESS,
	payload: fo_monan_chitiet[]
}
export interface IFoMonAnChiTietLoadErr {
	type: eFoMonAnChiTietActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IFoMonAnChiTietLoadDetailStart {
	type: eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_START,
	payload: number
}
export interface IFoMonAnChiTietLoadDetailSuccess {
	type: eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_SUCCESS,
	payload: fo_monan_chitiet
}
export interface IFoMonAnChiTietLoadDetailErr {
	type: eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_ERROR,
	payload: string
}
export interface IFoMonAnChiTietShowDetail {
	type: eFoMonAnChiTietActionTypeIds.SHOW_DETAIL,
	payload?: fo_monan_chitiet
}
export interface IFoMonAnChiTietCloseDetail {
	type: eFoMonAnChiTietActionTypeIds.CLOSE_DETAIL
}
export interface IFoMonAnChiTietChangeSelectedIds {
	type: eFoMonAnChiTietActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IFoMonAnChiTietShowConfirm {
	type: eFoMonAnChiTietActionTypeIds.SHOW_CONFIRM
}
export interface IFoMonAnChiTietCloseConfirm {
	type: eFoMonAnChiTietActionTypeIds.CLOSE_CONFIRM
}
export interface IFoMonAnChiTietSaveStart {
	type: eFoMonAnChiTietActionTypeIds.SAVE_START,
	payload: fo_monan_chitiet
}
export interface IFoMonAnChiTietSaveSuccess {
	type: eFoMonAnChiTietActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IFoMonAnChiTietSaveErr {
	type: eFoMonAnChiTietActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IFoMonAnChiTietDeleteStart {
	type: eFoMonAnChiTietActionTypeIds.DELETE_START,
	payload: number
}
export interface IFoMonAnChiTietDeleteSuccess {
	type: eFoMonAnChiTietActionTypeIds.DELETE_SUCCESS
}
export interface IFoMonAnChiTietDeleteErr {
	type: eFoMonAnChiTietActionTypeIds.DELETE_ERROR,
	payload: string
}

export type IFoMonAnChiTietActionTypes = IFoMonAnChiTietLoadStart | IFoMonAnChiTietLoadSuccess | IFoMonAnChiTietLoadErr |
	IFoMonAnChiTietLoadDetailStart | IFoMonAnChiTietLoadDetailSuccess | IFoMonAnChiTietLoadDetailErr |
	IFoMonAnChiTietShowDetail | IFoMonAnChiTietCloseDetail |
	IFoMonAnChiTietChangeSelectedIds |
	IFoMonAnChiTietShowConfirm | IFoMonAnChiTietCloseConfirm |
	IFoMonAnChiTietSaveStart | IFoMonAnChiTietSaveSuccess | IFoMonAnChiTietSaveErr |
	IFoMonAnChiTietDeleteStart | IFoMonAnChiTietDeleteSuccess | IFoMonAnChiTietDeleteErr
